(() => {
  const MIN_QTY = 4;

  async function getCart() {
    const r = await fetch("/cart.js", { credentials: "same-origin" });
    return r.json();
  }

  async function updateLine(key, qty) {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: key, quantity: qty }),
    });
  }

  async function enforce() {
    const cart = await getCart();
    if (!cart?.items?.length) return;

    // Since you have only one product: enforce min on first line
    const line = cart.items[0];
    if (line.quantity < MIN_QTY) {
      await updateLine(line.key, MIN_QTY);
      location.reload();
      return;
    }

    // Optional: disable checkout if somehow still below
    const checkoutBtn =
      document.querySelector('button[name="checkout"]') ||
      document.querySelector('a[href^="/checkout"]');

    if (checkoutBtn && cart.item_count < MIN_QTY) {
      checkoutBtn.style.pointerEvents = "none";
      checkoutBtn.style.opacity = "0.5";
    }
  }

  document.addEventListener("DOMContentLoaded", enforce);
})();